import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setScreenWidth } from '@/store/slices/common/screenWidthSlice';
import { RootState } from '@/store/index';

import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DesktopView from '@/pages/dashboard/main/desktopView';
import MobileView from '@/pages/dashboard/main/mobileView';

import HomeDefaultIcon from '@/assets/dashboard/navItems/tabHome.svg';
import WatchDefaultIcon from '@/assets/dashboard/navItems/watchDefaultIcon.png';
import EvaluationDefaultIcon from '@/assets/dashboard/navItems/evaluationDefaultIcon.png';
import HistoryDefaultIcon from '@/assets/dashboard/navItems/historyDefaultIcon.png';
import FavouriteDefaultIcon from '@/assets/dashboard/navItems/favouriteDefaultIcon.png';

import HomeDefaultWhiteIcon from '@/assets/dashboard/navItems/tabHomeWhite.png';
import WatchDefaultWhiteIcon from '@/assets/dashboard/navItems/watchDefaultWhiteIcon.png';
import EvaluationDefaultWhiteIcon from '@/assets/dashboard/navItems/evaluationDefaultWhiteIcon.png';
import HistoryDefaultWhiteIcon from '@/assets/dashboard/navItems/historyDefaultWhiteIcon.png';
import FavouriteDefaultWhiteIcon from '@/assets/dashboard/navItems/favouriteDefaultWhiteIcon.png';

import HomeHoverIcon from '@/assets/dashboard/navItems/tabHomeHover.png';
import WatchHoverIcon from '@/assets/dashboard/navItems/watchHoverIcon.png';
import EvaluationHoverIcon from '@/assets/dashboard/navItems/evaluationHoverIcon.png';
import HistoryHoverIcon from '@/assets/dashboard/navItems/historyHoverIcon.png';
import FavouriteHoverIcon from '@/assets/dashboard/navItems/favouriteHoverIcon.png';

import LightBlueHomeHoverIcon from '@/assets/dashboard/navItems/tabHomeHover.png';
import LightBlueWatchHoverIcon from '@/assets/dashboard/navItems/lightBlueWatchHoverIcon.png';
import LightBlueEvaluationHoverIcon from '@/assets/dashboard/navItems/lightBlueEvaluationHoverIcon.png';
import LightBlueHistoryHoverIcon from '@/assets/dashboard/navItems/lightBlueHistoryHoverIcon.png';
import LightBlueFavouriteHoverIcon from '@/assets/dashboard/navItems/lightBlueFavouriteHoverIcon.png';


import Footer from '@/components/common/footer';
import FloatingSupportButtons from '@/components/common/floatingSupportButtons';
import VeryTopNavbar from '@/components/common/veryTopNavbar';
import { Toaster } from 'sonner';

import { addCurrentThemeClassToEle } from '@/utils';
import "./indexStyle.css"
import { themes } from '@/constants/colors_v2';

export default function DashboardMain() {
    const dispatch = useDispatch();
    const screenWidth = useSelector((state: RootState) => state.screenWidthReducer.screenWidth);

    const { dashboard } = useLocalTranslation();

    type TabItem = {
        key: keyof typeof dashboard.tabs;
        defaultIcon: string;
        hoverIcon: string;
        darkThemeIcon: string;
        darkThemeHoverIcon: string;
    };

    const tabs: TabItem[] = [
        
        {
            key: 'home',
            defaultIcon: HomeDefaultIcon,
            hoverIcon: HomeHoverIcon,
            darkThemeIcon: HomeDefaultWhiteIcon,
            darkThemeHoverIcon: LightBlueHomeHoverIcon
        },
        
        {
            key: 'watch',
            defaultIcon: WatchDefaultIcon,
            hoverIcon: WatchHoverIcon,
            darkThemeIcon: WatchDefaultWhiteIcon,
            darkThemeHoverIcon: LightBlueWatchHoverIcon
        },
        // {
        //     key: 'evaluate',
        //     defaultIcon: EvaluationDefaultIcon,
        //     hoverIcon: EvaluationHoverIcon,
        //     darkThemeIcon: EvaluationDefaultWhiteIcon,
        //     darkThemeHoverIcon: LightBlueEvaluationHoverIcon
        // },
        {
            key: 'history',
            defaultIcon: HistoryDefaultIcon,
            hoverIcon: HistoryHoverIcon,
            darkThemeIcon: HistoryDefaultWhiteIcon,
            darkThemeHoverIcon: LightBlueHistoryHoverIcon
        },
        {
            key: 'favorite',
            defaultIcon: FavouriteDefaultIcon,
            hoverIcon: FavouriteHoverIcon,
            darkThemeIcon: FavouriteDefaultWhiteIcon,
            darkThemeHoverIcon: LightBlueFavouriteHoverIcon
        },
    ];

    const [activeKey, setActiveKey] = useState<string>('watch');
    const [isHydrated, setIsHydrated] = useState(false);

    const handleIntSetActiveKey = (val: string) => {
        setActiveKey(val);
    };

    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    useEffect(() => {
        dispatch(setScreenWidth(window.innerWidth));
        setIsHydrated(true)
        const handleResize = () => {
            dispatch(setScreenWidth(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    const getCurrentNavIconSrc = (activeKey: any, tab: any) => {
        // src={props.activeKey === tab.key ? tab.hoverIcon : tab.defaultIcon}
        if (activeKey === tab.key) {
            if (window.innerWidth < 1200) {
                return tab.hoverIcon
            }
            else if (currentTheme === themes.dark) {
                return tab.darkThemeHoverIcon
            } else {
                return tab.hoverIcon
            }

        }

        if (currentTheme === themes.dark) {
            return tab.darkThemeIcon
        } else {
            return tab.defaultIcon
        }
    }

    return (
        <div className={`min-h-screen font-roboto
          mt-[45px] min-[1280px]:mt-0
          ${addCurrentThemeClassToEle(currentTheme, 'dashboardTheMainIndex')}`}>
            {isHydrated &&
                <>
                    {/* <VeryTopNavbar
                        showRhs={true}
                    /> */}
                    {screenWidth > 1200 ? (
                        <DesktopView
                            activeKey={activeKey}
                            handleIntSetActiveKey={handleIntSetActiveKey}
                            tabs={tabs.splice(1)}
                            dashboard={dashboard}
                            getCurrentNavIconSrc={getCurrentNavIconSrc}
                        />
                    ) : (
                        <MobileView
                            activeKey={activeKey}
                            handleIntSetActiveKey={handleIntSetActiveKey}
                            tabs={tabs}
                            dashboard={dashboard}
                            getCurrentNavIconSrc={getCurrentNavIconSrc}
                        />
                    )}
                    {/* <Footer /> */}
                    <FloatingSupportButtons />

                    <Toaster richColors />

                </>
            }
        </div>
    );
}
